// extracted by mini-css-extract-plugin
export default {"layoutRest":"layout_layoutRest__1XrC+","layoutSidebar":"layout_layoutSidebar__gN5yD","layoutChildren":"layout_layoutChildren__15bl7"};